import { useQuery } from '@tanstack/react-query';

import { API } from '../constants';
import { apiClient } from '../lib/apiClient';
import { VersionStructure } from '../types';

const PRIVACY_VERSION_QUERY_KEY = 'legal-version';

export const useGetPrivacyVersion = () => {
    return useQuery({
        queryKey: [PRIVACY_VERSION_QUERY_KEY],
        queryFn: async (): Promise<VersionStructure> => {
            const { data } = await apiClient.get<VersionStructure>(API.LEGAL_UPDATE);
            return data;
        },
        staleTime: 60 * 60 * 1000, // 1 hour — static data
    });
};
